/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component, Input, forwardRef, Inject } from "@angular/core";
import { Tabs } from "./tabs";
var TabLink = (function () {
    function TabLink(tabs) {
        this.tabs = tabs;
        this.active = false;
    }
    TabLink.prototype.onClick = function () {
        this.tabs.selectTab(this);
        return false; // so that browser doesn't navigate to the href of the anchor tag
    };
    return TabLink;
}());
export { TabLink };
TabLink.decorators = [
    { type: Component, args: [{
                selector: "clr-tab-link",
                template: "\n      <!--\n        ~ Copyright (c) 2016 VMware, Inc. All Rights Reserved.\n        ~ This software is released under MIT license.\n        ~ The full license information can be found in LICENSE in the root directory of this project.\n        -->\n\n      <button class=\"btn btn-link nav-link\" (click)=\"onClick()\" type=\"button\">\n          <ng-content></ng-content>\n      </button>\n    ",
                host: {
                    "[id]": "id",
                    "[attr.aria-selected]": "active",
                    "[attr.aria-controls]": "ariaControls",
                    "role": "presentation",
                    "[class.nav-item]": "true",
                    "[class.active]": "active"
                }
            },] },
];
/** @nocollapse */
TabLink.ctorParameters = function () { return [
    { type: Tabs, decorators: [{ type: Inject, args: [forwardRef(function () { return Tabs; }),] },] },
]; };
TabLink.propDecorators = {
    'active': [{ type: Input, args: ["clrTabLinkActive",] },],
    'id': [{ type: Input, args: ["clrTabLinkId",] },],
};
//# sourceMappingURL=tab-link.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/layout/tabs/tab-link.js
// module id = 58
// module chunks = 4